import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box, Card } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import ModeEditIcon from "@mui/icons-material/ModeEdit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useLocation } from "react-router-dom";
import {
  StyledTableRow,
  StyledTableCell,
} from "../style/style";
import { timeStamp } from "../apicall/commonFunction";
import Pagination from "@mui/material/Pagination";

export default function ReplacedDeviceList(props) {
  const location = useLocation();
  console.log(location.pathname);
  const handlePagechange = (event, value) => {
    props.setPage(value);
  };
  const handleOpenEditModal = (selectedDevice) => {
    props.setSelectedDevice(selectedDevice);
    props.setOpenEditModal(true);
  };
  const handleViewModal = (selectedDevice) => {
    props.setSelectedDevice(selectedDevice);
    props.setOpenViewModal(true);
  };
  return (
    <div>
      <Box>
        <Card>
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    <b>Company Name</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>IMEI</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>ICCID</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Replacement Status</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Reported On</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Replaced on</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Action</b>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.devices
                  ? props.devices.map((device) => (
                      <StyledTableRow key={device.id}>
                        <StyledTableCell>{device.company_name}</StyledTableCell>
                        <StyledTableCell>
                          {device.old_device_imei}
                        </StyledTableCell>
                        <StyledTableCell>
                          {device.old_device_iccid}
                        </StyledTableCell>
                        <StyledTableCell>
                          {device.status ? "Replaced" : "In-Process"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {timeStamp(parseInt(device.created_at))}
                        </StyledTableCell>
                        <StyledTableCell>
                          {device.replaced_at
                            ? timeStamp(parseInt(device.replaced_at))
                            : "NA"}
                        </StyledTableCell>
                        <StyledTableCell>
                          <div style={{ display: "flex" }}>
                            {location.pathname === "/admin" && (
                              <Tooltip
                                title={
                                  device.status
                                    ? "Device Already Replaced"
                                    : "Replace Device"
                                }
                              >
                                <div>
                                  <IconButton
                                    variant="contained"
                                    size="small"
                                    disabled={device.status}
                                    onClick={() => {
                                      handleOpenEditModal(device);
                                    }}
                                  >
                                    <ModeEditIcon />
                                  </IconButton>
                                </div>
                              </Tooltip>
                            )}
                            <Tooltip
                              title={
                                device.status
                                  ? "View Replacement Details"
                                  : "Device Not Replaced Yet"
                              }
                            >
                              <div>
                                <IconButton
                                  variant="contained"
                                  size="small"
                                  disabled={!device.status}
                                  onClick={() => {
                                    handleViewModal(device);
                                  }}
                                >
                                  <RemoveRedEyeIcon color="primary" />
                                </IconButton>
                              </div>
                            </Tooltip>
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  : null}
              </TableBody>
              <Pagination
                count={props.totalPage}
                page={props.page}
                variant="outlined"
                color="primary"
                onChange={handlePagechange}
              />
            </Table>
          </TableContainer>
        </Card>
      </Box>
    </div>
  );
}
